<template>
    <div class="c-na" :style="wrapStyle">
        <div :style="innerStyle">
            <CornerOrnament v-if="!isMobile" corner="tr" :size="180" :opacity="0.3" />
            <CornerOrnament v-if="!isMobile" corner="bl" :size="180" :opacity="0.3" />

            <div :style="cardWrapStyle">
                <div :style="checkStyle">✓</div>
                <div :style="eyebrowStyle">All caught up</div>
                <h1 :style="h1Style">
                    {{ agencyName }}'s action plan for
                    <span :style="accentStyle">{{ currentMonth }}</span>
                    is complete.
                </h1>
                <p :style="leadStyle">
                    Nothing else for you to do this period. We'll be back next month.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import { scrollToTop } from "../../../helpers/_scrollToTop";

import CornerOrnament from "../c-design/CornerOrnament.vue";
import viewportMixin from "../c-design/useViewport";
import {
    C_BG,
    C_INK,
    C_MUTED,
    C_GREEN,
    C_RED,
    FONT_DISPLAY,
} from "../c-design/tokens";

/**
 * Stage 10a of the wizard redesign (Wizard leftovers Epic).
 * The empty-state landing the parent flips to when dashboard_data.page
 * is empty — there's nothing for the agency to fill in for the month.
 * Mirror of ThankYou.vue / DoneC, but with copy that fits the
 * "nothing to do" framing instead of "submission received".
 */
export default {
    name: "Wizard_No_Actions",
    mixins: [viewportMixin],
    components: { CornerOrnament },
    computed: {
        currentMonth: () => {
            return moment().format("MMMM'YY");
        },
        agencyName() {
            return this.$store.getters.getAgencyName;
        },
        wrapStyle() {
            return {
                background: C_BG,
                minHeight: '70vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: this.isMobile ? '20px 16px' : '32px',
                position: 'relative',
            };
        },
        innerStyle() {
            return {
                position: 'relative',
                width: '100%',
                maxWidth: '560px',
            };
        },
        cardWrapStyle() {
            return {
                position: 'relative',
                zIndex: 1,
                textAlign: 'center',
                padding: '40px 32px',
            };
        },
        checkStyle() {
            return {
                width: '72px',
                height: '72px',
                borderRadius: '50%',
                background: C_GREEN,
                color: '#fff',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '36px',
                fontWeight: 700,
                marginBottom: '20px',
            };
        },
        eyebrowStyle() {
            return {
                fontSize: '12px',
                color: C_GREEN,
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
                fontWeight: 700,
                marginBottom: '8px',
            };
        },
        h1Style() {
            return {
                margin: '0 0 12px',
                fontFamily: FONT_DISPLAY,
                fontSize: this.isMobile ? '28px' : '36px',
                fontWeight: 700,
                letterSpacing: this.isMobile ? '-0.9px' : '-1.1px',
                lineHeight: 1.1,
                color: C_INK,
            };
        },
        accentStyle() {
            return { color: C_RED };
        },
        leadStyle() {
            return {
                margin: 0,
                fontSize: '15px',
                color: C_MUTED,
                lineHeight: 1.55,
            };
        },
    },
    mounted() {
        scrollToTop();
    },
    methods: {},
};
</script>
